import { render, staticRenderFns } from "./IconEstablishment.vue?vue&type=template&id=6550b6b8"
import script from "./IconEstablishment.vue?vue&type=script&lang=js"
export * from "./IconEstablishment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports